export default {
  title: 'Varausten saatavuus',
};
